<template>
  <component :is="tag" data-module="CmsArticleList">
    <slot :list="list" v-if="!loading"></slot>
  </component>
</template>

<script>
import {getNotices} from "~/api/CmsApi";

export default {
  name: 'CmsNoticeList',
  props: {
    /**
     * 父栏目ID
     */
    columnId: {
      type: [String, Number],
      default: '1'
    },
    /**
     * 分页查询起始页
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页大小
     */
    limit: {
      type: Number,
      default: 10
    },
    /**
     * 指定元素渲染出的标签
     */
    tag: {
      type: String,
      default: 'div'
    },
    sortBy: {
      type: String,
      default: 'sort'
    },
  },
  data() {
    return {
      loading: true,
      list: []
    };
  },
  watch: {
    columnId: {
      handler(value) {
        if (value) {
          this.initialize();
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    initialize() {
      const param = { page: this.page, limit: this.limit, displayFilter: '1', columnId: this.columnId };
     
      getNotices(param).then(res => {
        if (res.code === 0) {
          const list = res.data.records || [];
          if (this.sortBy === 'sort') {
            list.sort((a, b) => a.sort - b.sort);
          }
          this.list = list;
          this.$emit('loaded', list);
        } else {
          console.warn('通知获取失败');
        }
        this.loading = false;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsNoticeList.vue